/** Форматери. null скрізь означає «дані відсутні», і UI має це показувати чесно. */

export function formatUsd(value: number | null): string | null {
	if (value === null) return null;
	return `$${value.toLocaleString('en-US')}`;
}

/**
 * Сума з бекенда приходить рядком «1500.00». Показуємо без копійок, як усюди
 * в інтерфейсі: цим займались дві копії однієї функції в різних компонентах.
 */
export function formatUsdAmount(value: string): string {
	return `$${Math.round(Number(value)).toLocaleString('en-US')}`;
}

export function formatMiles(value: number | null): string | null {
	if (value === null) return null;
	return `${value.toLocaleString('en-US')} mi`;
}

/** «in 2d 4h» / «in 45m» / «ended». Аукціонний час — головна вісь у цьому продукті. */
export function formatTimeUntil(iso: string | null, now = Date.now()): string | null {
	if (!iso) return null;
	const ts = new Date(iso).getTime();
	if (Number.isNaN(ts)) return null;

	const diffMin = Math.round((ts - now) / 60_000);
	if (diffMin <= 0) return 'ended';

	const days = Math.floor(diffMin / 1440);
	const hours = Math.floor((diffMin % 1440) / 60);
	const minutes = diffMin % 60;

	if (days > 0) return `in ${days}d ${hours}h`;
	if (hours > 0) return `in ${hours}h ${minutes}m`;
	return `in ${minutes}m`;
}

export function formatAuctionDate(iso: string | null): string | null {
	if (!iso) return null;
	const d = new Date(iso);
	if (Number.isNaN(d.getTime())) return null;
	return d.toLocaleDateString('en-US', { month: 'short', day: 'numeric', year: 'numeric' });
}

/**
 * Час торгів за Дубаєм: «Sat, 13 Sep · 05:46 GST». Дилери — в ОАЕ, а
 * аукціон — у США: місцевий час браузера тут легко хибно прочитати, тож
 * часовий пояс називаємо явно.
 */
export function formatDubaiTime(iso: string | null, withDate = true): string | null {
	if (!iso) return null;
	const d = new Date(iso);
	if (Number.isNaN(d.getTime())) return null;
	// Частини окремо: en-GB цілим рядком дає «Sept» і губить кому після дня тижня.
	const part = (options: Intl.DateTimeFormatOptions): string =>
		d.toLocaleString('en-US', { timeZone: 'Asia/Dubai', ...options });
	const time = `${part({ hour: '2-digit', minute: '2-digit', hourCycle: 'h23' })} GST`;
	if (!withDate) return time;
	return `${part({ weekday: 'short' })}, ${part({ day: 'numeric' })} ${part({ month: 'short' })} · ${time}`;
}

/**
 * Заголовок лота: рік + марка + повна модель, людським регістром
 * («2013 Lincoln MKZ Hybrid», а не капс провайдера). Правила — у lotTitle.
 */
export { lotTitle as vehicleName } from './vehicle-labels';
